module.exports = {
  title: 'QR Code Generator with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-07-19',
  slug: 'qr-code-generator',
  tags: ['skia'],
};
